export const tourSteps = {
  home: [
    {
      selector: ".first-step",
      content:
        "Select incident ID to start editing  the postmortem corresponding to that incident",
    },
    {
      selector: ".second-step",
      content: "Click here to view the current on-going postmortems",
    },
    {
      selector: ".third-step",
      content:
        "You can have a clear sight on insights which can give you like how many P1 incidents are there,incident trend and Portfolio wise actions trend",
    },
    {
      selector: ".fifth-step",
      content: "Click here to view the archived postmortems, postmortems which are completed",
    },
    {
      selector: ".fourth-step",
      content:
        "Create a new postmortem",
    },
  ],

  editPageSteps: [
    {
      selector: ".first-step",
      content:
        "Give incident ID to start editing postmortem corresponding to that incident",
    },
    {
      selector: ".second-step",
      content: "Stages for a particular postmortem",
    },
    {
      selector: ".third-step",
      content: "Meta Data for a particular postmortem",
    },
    {
      selector: ".fourth-step",
      content:
        "Assign this postmortem by selecting a portfolio, related platforms, a product, and the desired application.This information has to be filled by caused by CI",
    },
    {
      selector: ".fifth-step",
      content:
        "Sections for postmortem, you can navigate to next section by clicking on the next button.",
    },
    // {
    //   selector: ".sixth-step",
    //   content:
    //     "Click on the pencil icon to start editing the postmortem sections",
    // },

    // // {
    // //   selector: ".seventh-step",
    // //   content:
    // //     "This section deals with the Feedback comments given by the SRE or L.T., if there is a new comment given it will be in the new section, once you have read the comment and performed the required action you can drag and drop it in te review section",

    // // },
    // {
    //   selector: ".seventh-step",
    //   content: "Delegate this postmortem / Add collaborators",
    // },
    // {
    //   selector: ".eighth-step",
    //   content:
    //     'You can upload the images by clicking on "plus" icon, please refer to the accepted image size and format',
    // },
  ],

  insights: [
    // {
    //   selector: ".first-step",
    //   content:
    //     "Give incident ID to start editing postmortem corresponding to that incident",
    //   condition: elementExists(".first-step"),
    // },
    {
      selector: ".second-step",
      content:"Percentage of postmortems which are caused by a change"
      // content: "P1 incidents occurred in year 2022-2023",
    },
    {
      selector: ".third-step",
      content:"Current open postmortems"
      // content: "Postmortems which are in review stage",
    },
    {
      selector: ".fourth-step",
      content:"Total Incidents"
      // content: "Postmortems which are in review stage",
    },
    {
      selector: ".fifth-step",
      content:"Postmortems in Review"
      // content: "Postmortems which are in review stage",
    },
    {
      selector: ".sixth-step",
      content: "Avg MTTS considering all postmortems"
      // content: "Incident trend of P1 Incidents for the past one year",
    },
    {
      selector: ".seventh-step",
      // content:
      content: "Incident trend of Incidents for the past one year",
        // "Jira and Ptasks associated with a portfolio. Click on the dropdown to select the portfolio and view the Jira and Ptasks associated with that portfolio",
    },

    {
      selector: ".eight-step",
      // content:
      content: "Filters for the below insights",
        // "Jira and Ptasks associated with a portfolio. Click on the dropdown to select the portfolio and view the Jira and Ptasks associated with that portfolio",
    },
    // {
    //   selector: ".ninth-step",
    //   // content:
    //   content: "Incidents based on portfolio/platform",
    //     // "Jira and Ptasks associated with a portfolio. Click on the dropdown to select the portfolio and view the Jira and Ptasks associated with that portfolio",
    // },
  ],

  // ...
};

export const postmortemSectionTourSteps = {
  incidentSummary: [
    {
      selector: ".how-to-edit",
      content: "Click on the pencil icon to start editing the incident summary",
    },
    {
      selector: ".summary",
      content: "This section deals with the summary of the incident",
    },
    {
      selector: ".image-upload-div-tour-step",
      content:
        "This section deals with all the images uploaded for the summary",
    },
    {
      selector: ".new-image-upload-div-tour-step",
      content:
        "Click on the + symbol to start uploading the images for the summary",
    },
    {
      selector: ".precedingevents-tour-step",
      content: "This section deals with the preceding events of the incident",
    },
    {
      selector: ".image-upload-div-tour-step-preceding-events",
      content:
        "This section deals with all the images uploaded for the preceding events of the incident",
    },
    {
      selector: ".new-image-upload-div-tour-step-preceding-events",
      content:
        "Click on the + symbol to start uploading the images for the preceding events of the incident",
    },
    {
      selector: ".impact-div-touring-step",
      content: "This section deals with the impact of the incident",
    },
    {
      selector: ".image-upload-div-tour-step-impact",
      content:
        "This section deals with all the images uploaded for the impact of the incident",
    },
    {
      selector: ".new-image-upload-div-tour-step-impact",
      content:
        "Click on the + symbol to start uploading the images for the impact of the incident",
    },
    {
      selector: ".dar-div-tour-step",
      content:
        "This section deals with the detection and response of the incident",
    },
  ],

  rootCause: [
    {
      selector: ".recovery-edit-icon",
      content: "Click on the pencil icon to start editing the recovery",
    },
    {
      selector: ".recovery-description-div-tour-step",
      content: "This section deals with the recovery description",
    },
    {
      selector: ".rootCause-identification-edit-icon",
      content:
        "Click on the pencil icon to start editing the root cause identification",
    },
    {
      selector: ".rootCause-identification-description-div-tour-step",
      content: "This section deals with the root identification description",
    },
    {
      selector: ".image-upload-div-tour-step-rootCause-identification",
      content:
        "This section deals with all the images uploaded for the rootCause identification of the incident",
    },
    {
      selector: ".new-image-upload-div-tour-step-rootCause-identification",
      content:
        "Click on the + symbol to start uploading the images for the rootCause identification of the incident",
    },
    {
      selector: ".five-why-div-tour-step",
      content:"This section deals with the 5 why's of the incident",
    },
    {
      selector:".root-cause-edit-icon-tour-step",
      content:"Click on the pencil icon to start editing the root cause",
    },
    {
      selector:".root-cause-cause-div-tour-step",
      content:"This section deals with the cause of the incident",
    },
    {
      selector:".root-cause-cause-code-div-tour-step",
      content:"This section deals with the cause code of the incident",
    },
    {
      selector:".root-cause-sub-code-div-tour-step",
      content:"This section deals with the sub code of the incident",
    },
    {
      selector:".root-cause-image-upload-div-tour-step",
      content:"This section deals with all the images uploaded for the root cause of the incident",
    },
    {
      selector:".root-cause-new-image-upload-div-tour-step",
      content:"Click on the + symbol to start uploading the images for the root cause of the incident",
    },
    {
      selector:".root-cause-tag-div-tour-step",
      content:"This section deals with the tag of the incident",
    },
    // {
    //   selector:".root-cause-change-number-div-tour-step",
    //   content:"This section deals with the change number of the incident",
    // },
    // {
    //   selector:".root-cause-change-vendor-div-tour-step",
    //   content:"This section deals with the vendor related to the incident",
    // },
    // {
    //   selector:".recurrence-edit-div-tour-step",
    //   content:"Click on the pencil icon to start editing the recurrence",
    // },
    // {
    //   selector:".recurrences-change-number-div-tour-step",
    //   content:"This section deals with the change number of the last similar incident",
    // },
    // {
    //   selector:".recurrences-problemId-div-tour-step",
    //   content:"This section deals with the problem ID of the last similar incident",
    // }
  ],


  pTasks: [
    {
      selector:".ptask-add-tour-step",
      content:"Click on the button to start adding/editing the ptask",
    },
    {
      selector:".ptask-image-upload-div-tour-step",
      content:"This section deals with all the images uploaded for the ptask",
    },
    {
      selector:".ptask-new-image-upload-div-tour-step",
      content:"Click on the + symbol to start uploading the images for the ptask",
    },
    {
      selector:".ptasks-table-tour-step",
      content:"This section deals with all the pTasks added",
    },
  ],
  jira:[
    {
      selector:".jira-ticket-add-tour-step",
      content:"Click on the button to start adding/editing the jira ticket",
    },
    {
      selector:".jira-ticket-image-upload-div-tour-step",
      content:"This section deals with all the images uploaded for the jira ticket",
    },
    {
      selector:".jira-ticket-new-image-upload-div-tour-step",
      content:"Click on the + symbol to start uploading the images for the jira ticket",
    },
    {
      selector:".jira-tickets-table-tour-step",
      content:"This section deals with all the jira tickets added",
    },
  ]
};
